import { createContext, useReducer } from "react";
import PropTypes from "prop-types";

// Set up our reducer function to act on Previous and Next selections
function reducer(state, action) {
    switch (action.type) {
        case "AdwCalled":
            return {
                ...state,
                adwCalled: action.adwCalled || false
            };
        case "Guid":
            return {
                ...state,
                guid: action.guid
            };
        case "GuardianStudentMap":
            return {
                ...state,
                guardianStudentMap: action.guardianStudentMap
            };
        case "IcStudentInfo":
            return {
                ...state,
                icStudentInfo: action.icStudentInfo
            };
        case "Lang":
            return {
                ...state,
                lang: action.lang
            };
        case "OeActionControl":
            return {
                ...state,
                oeActionControl: action.oeActionControl
            };
        case "OeAllActionControls":
            return {
                ...state,
                oeAllActionControls: action.oeAllActionControls
            };
        case "OeActiveDistrictWindow":
            return {
                ...state,
                oeActiveDistrictWindow: action.oeActiveDistrictWindow
            };
        case "OeDistrictWindows":
            return {
                ...state,
                oeDistrictWindows: action.oeDistrictWindows
            };
        case "OeSchoolYearKey":
            return {
                ...state,
                oeSchoolYearKey: action.oeSchoolYearKey
            };
        case "OeStudentInfo":
            return {
                ...state,
                oeStudentInfo: action.oeStudentInfo
            };
        case "OeWindows":
            return {
                ...state,
                oeWindows: action.oeWindows
            };
        case "SchoolYearDto":
            return {
                ...state,
                schoolYearDto: action.schoolYearDto
            };
        case "SchoolYearKey":
            return {
                ...state,
                schoolYearKey: action.schoolYearKey
            };
        case "StudentImageUrl":
            return {
                ...state,
                studentImageUrl: action.studentImageUrl
            };
        case "StudentKey":
            return {
                ...state,
                studentKey: action.studentKey
            };
        case "StudentNumber":
            return {
                ...state,
                studentNumber: action.studentNumber
            };
        case "Token":
            return {
                ...state,
                token: action.token
            };
        case "UserDetails":
            return {
                ...state,
                userDetails: action.userDetails
            };
        case "Username":
            return {
                ...state,
                username: action.username
            };
        default:
            return { token: null };
    }
}

// Set the count to 0
const initialState = { token: null, username: null };
// Create a counter context, initially storing the initialState
const GlobalContext = createContext(initialState);
// Create a counter-provider to pass down the
const ContextProvider = ({ children }) => {
    const [state, dispatch] = useReducer(reducer, initialState);
    return (
        /**
         * Pass an object with the current state and dispatch values as props
         * to the context provider and allow all children of <CounterProvider/>
         * component to have these context values
         */
        // eslint-disable-next-line react/jsx-no-constructed-context-values
        <GlobalContext.Provider value={{ state, dispatch }}>{children}</GlobalContext.Provider>
    );
};

ContextProvider.propTypes = {
    children: PropTypes.node
};

ContextProvider.defaultProps = {
    children: null
};

export { GlobalContext, ContextProvider };
